import { render, staticRenderFns } from "./CarouselMessage.vue?vue&type=template&id=4d382a0f&scoped=true&"
import script from "./CarouselMessage.vue?vue&type=script&lang=js&"
export * from "./CarouselMessage.vue?vue&type=script&lang=js&"
import style0 from "./CarouselMessage.vue?vue&type=style&index=0&id=4d382a0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d382a0f",
  null
  
)

export default component.exports